

// --------------------------------------- Project List
export const ProjectList = [
    {
        img: "Portfolio - d1.png",
        title: "Portfolio",
        description:
            "Portfolio website with contact form for a tattoo artist. Displayed here the main view. Admin space to come.",
        img_credit: "Solanum Bean - Tattoo artist",
        figma_url: "https://www.figma.com/file/mCbdyJuTElI4FYw3kIIISK/Portfolio---public?type=design&node-id=0%3A1&mode=design&t=gA6kUQPKZ6KnnEWa-1",
        tech_stack: "React, Node, TypeScript",
        github_url: "https://github.com/AliceXix/panda-portfolio",
        demo_url: "https://solanum-bean-tattoo.netlify.app"
    },
    {
        img: "project - memoriez.png",
        title: "Memoriez",
        description: "Personal project. Targets people with anxiety, fear of abandonment, etc and allows them to collect memories with people in their social environment in order to calm themselves when having episodes.",
        tech_stack: "React, Node, Express, Mongo, RESTful API, Jest, TypeScript",
        github_url: "https://github.com/AliceXix/Memoriez"
    },
    {
        img: "project - moodshaker.png",
        title: "Moodshaker",
        description:
            "Bootcamp project after 5 weeks. With Moodshaker you get activity ideas tailored to how you feel.",
        tech_stack: "HTML, CSS, JavaScript, Handelbars, Express, Node, Mongo",
        github_url: "https://github.com/French-Connection-Ironhack/moodshaker",
        //demo_url: "https://mood-shaker.herokuapp.com",
    },
    {
        img: "project - social gratitude.jpeg",
        title: "Social Gratitude",
        description: "Bootcamp project after 7,5 weeks. Social Gratitude let's you share what you are grateful for with your social environment.",
        tech_stack: "React, CSS, JavaScript, Express, Node, Mongo, RESTful API",
        github_url: "https://github.com/Alice-Nekruz/social-gratitude-server",
        //demo_url: "https://social-gratitude.netlify.app",
    },
    {
        img: "project - fliperz.jpeg",
        title: "Fliperz",
        description: "Bootcamp project after 2 weeks. Fliperz is a flashcard based learning game.",
        tech_stack: "HTML, CSS, JavaScript",
        github_url: "https://github.com/AliceXix/learning-game-flashcards",
        demo_url: "https://alicexix.github.io/learning-game-flashcards/",
    }
];

// --------------------------------------- Skills

export const stackList = [
    {
        img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/javascript.svg",
        name: "JavaScript",
    },
    {
        img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/react.svg",
        name: "React classes",
    },
    {
        img: "logos/react-hooks_logo.png",
        name: "React Hooks"
    },
    {
        img: "logos/Typescript_logo.svg",
        name: "TypeScript"
    },
    {
        img: "logos/nodejs_logo.svg",
        name: "NodeJS"
    },
    {
        img: "logos/expressjs_logo.png",
        name: "ExpressJS"
    },
    {
        img: "logos/mongodb-logo.png",
        name: "MongoDB"
    },
    {
        img: "logos/rest-api.png",
        name: "RESTful API",
    },
    {
        img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/html5.svg",
        name: "HTML",
    },
    {
        img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/css3.svg",
        name: "CSS",
    },
    {
        img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/git.svg",
        name: "Git",
    },
    {
        img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/responsive.svg",
        name: "Responsive",
    },
    {
        img: "logos/agile_logo.jpg",
        name: "Agile"
    },
    {
        img: "logos/docker_logo.png",
        name: "Docker"
    },
];

export const stackListLearning = [
    {
        img: "logos/python.png",
        name: "Python"
    },
    {
        img: "logos/TDD_logo.webp",
        name: "TDD"
    },
    {
        img: "logos/docker_logo.png",
        name: "Docker"
    },
    {
        img: "logos/jest_logo.jpeg",
        name: "Jest"
    },
    {
        img: "logos/golang_logo.png",
        name: "Golang"
    },
]

export const stackListInterest = [
    {
        img: "logos/AWS_logo.png",
        name: "AWS"
    },
    {
        img: "logos/postgresql_logo.jpg",
        name: "postgreSQL"
    },
]